import { useUsers } from '@/features/users'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/components/atoms/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shared/components/atoms/ui/table'

export function SettingsPage() {
	const { data: users, isLoading } = useUsers()

	// Filter for active users only (logged in users)
	const activeUsers = users?.filter((user) => user.isActive) || []

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-64">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground" />
			</div>
		)
	}

	return (
		<div className="space-y-6">
			<div>
				<h1 className="text-2xl font-bold text-foreground">Settings</h1>
				<p className="text-sm text-muted-foreground mt-1">Manage your account settings and preferences</p>
			</div>

			<Card>
				<CardHeader>
					<CardTitle>Active Users</CardTitle>
					<CardDescription>
						List of all currently active users in the system ({activeUsers.length} user
						{activeUsers.length !== 1 ? 's' : ''})
					</CardDescription>
				</CardHeader>
				<CardContent>
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>Name</TableHead>
								<TableHead>Email</TableHead>
								<TableHead>Role</TableHead>
								<TableHead>Status</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{activeUsers.length === 0 ? (
								<TableRow>
									<TableCell colSpan={4} className="text-center py-8 text-muted-foreground">
										No active users found
									</TableCell>
								</TableRow>
							) : (
								activeUsers.map((user) => (
									<TableRow key={user.userId}>
										<TableCell className="font-medium">{user.displayName || '—'}</TableCell>
										<TableCell>{user.email}</TableCell>
										<TableCell>
											<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
												{user.role}
											</span>
										</TableCell>
										<TableCell>
											<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
												Active
											</span>
										</TableCell>
									</TableRow>
								))
							)}
						</TableBody>
					</Table>
				</CardContent>
			</Card>
		</div>
	)
}
